export interface CognitoError extends Error {
  name: string;
  message: string;
}

export function isCognitoError(error: unknown): error is CognitoError {
  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    typeof (error as any).name === "string"
  );
}
